import React from 'react';
import PropTypes from 'prop-types';
import { v4 } from 'uuid';
import { Icon } from '~/components';
import images from '~/constants/images';
import * as S from './styles';

export default function CourtDiagram({ formation, inverted, hovered }) {
  return (
    <S.Court inverted={inverted}>
      <img src={images.horizontalHalfField} alt="court" />
      <S.ColumnContainer inverted={inverted}>
        {formation.map(column => {
          return (
            <S.Column key={v4()} inverted={inverted}>
              {column.map(cell => {
                if (cell !== null) {
                  return (
                    <Icon
                      key={v4()}
                      name="miniShirt"
                      size={23}
                      color={hovered === cell.shirtNumber ? 'coral' : 'white'}
                      text={cell ? cell.shirtNumber : ''}
                    />
                  );
                }
                return null;
              })}
            </S.Column>
          );
        })}
      </S.ColumnContainer>
    </S.Court>
  );
}

CourtDiagram.propTypes = {
  formation: PropTypes.array,
  inverted: PropTypes.bool,
  hovered: PropTypes.string,
};

CourtDiagram.defaultProps = {
  formation: [],
  inverted: false,
  hovered: '0',
};
